import { get, post } from "./http";

export const ConfigInit = (p) => get("/api/v1.index/init", p); //配置信息
export const GetBanner = (p) => get("/api/v1.index/banners", p); //首页轮播图
export const Login = (p) => post("/api/v1.user/accountLogin", p); //登录
export const GetUserInfo = (p) => post("/api/v1.user/data", p); //用户信息
export const HotSearch = (p) => post("/api/v1.index/hot_search", p); //热门搜索

// --------------------蒋--------------------
export const GetCategoryList = (p) => post("/api/v1.index/category_tree", p); //首页获取分类
export const GetMessageList = (p) => get("/api/v1.message/message_list", p); //首页获取分类
export const GetActivityList = (p) => get("/api/v1.index/activity_list", p); //首页获取活动列表
export const GetHotGoodsList = (p) => get("/api/v1.index/hot_goods", p); //首页获取热门产品列表
export const GetBrandListList = (p) => get("/api/v1.index/brands", p); //首页获取推荐品牌列表
export const GetActivity = (p) => get("/api/v1.activity", p); //首页获取活动列表1

// --------------------易--------------------
export const MyInstitution = (p) => post("/api/v1.institution/myinstitution", p); //用户&机构信息
export const SaveContact = (p) => post("/api/v1.institution/institution_contact", p); //保存联系人姓名
export const SaveIns = (p) => post("/api/v1.institution/institution_auth", p); //保存机构
export const IdcardSpot = (p) => post("/api/v1.index/idcard_shibie", p); //身份证识别
export const LicenseSpot = (p) => post("/api/v1.index/yingye", p); //营业执照识别
export const Vip = (p) => post("/api/v1.vip", p); //Vip
export const Address = (p) => post("/api/v1.user_address", p); //地址列表
export const AddressAdd = (p) => post("/api/v1.user_address/add", p); //地址新增
export const AddressDel = (p) => post("/api/v1.user_address/batch_delete", p); //地址删除
// export const getOrderSearch = (p) => post("/api/v1.order/search_data", p); //获取订单搜索数据
export const getOrder = (p) => post("/api/v1.order", p); //获取订单列表
export const OrderCacncel = (p) => post("/api/v1.order/cancel", p); //取消订单
export const OrderDetail = (p) => post("/api/v1.order/detail", p); //订单详情
export const OrderExpress = (p) => post("/api/v1.order/logistics", p); //订单物流
export const ItemDetail = (p) => post("/api/v1.order/itemDetail", p); //订单详情
export const Apply = (p) => post("/api/v1.aftersale/add", p); //订单申请退款

// --------------------陈--------------------
export const getArea = (p) => get("/api/v1.index/area_tree", p); //获取省市区
export const getBusiness = (p) => get("/api/v1.index/business", p); //获取机构类型
export const getCode = (p) => post("/api/sms/send", p, true); //获取短信验证码
export const getAgreement = (p) => get("/api/v1.singlepage/singlepage", p); //获取隐私政策和用户协议
export const identifyId = (p) => post("/api/v1.index/idcard_shibie", p); //识别身份证
export const identifyLicense = (p) => post("/api/v1.index/yingye", p); //识别营业执照
export const register = (p) => post("/api/v1.user/register", p); //注册
export const resetPwd = (p) => post("/api/v1.user/resetPwd", p); //重置密码
export const getInstitution = (p) => get("/api/v1.institution", p); //获取子机构列表
export const addInstitution = (p) => post("/api/v1.institution/add_institution", p); //添加子机构
export const delInstitution = (p) => post("/api/v1.institution/delete", p); //删除子机构
export const getInstDetail = (p) => post("/api/v1.institution/detail", p); //子机构信息
export const getInstDetailOrder = (p) => get("/api/v1.institution/order_list", p); //子机构订单列表
export const getOrderSearch = (p) => get("/api/v1.order/search_data", p); //活动类型
export const getAfterSale = (p) => get("/api/v1.aftersale", p); //子机构售后订单
export const cancelOrder = (p) => post("/api/v1.order/cancel", p,true); //取消订单
export const getCollection = (p) => get("/api/v1.goods_log/index", p); //我的收藏
export const cancelCollection = (p) => post("/api/v1.goods_log/batch_favorite", p); //取消收藏
export const getHelper = (p) => get("/api/v1.singlepage/articles", p); //获取帮助
export const getHelpDetail = (p) => get("/api/v1.singlepage/article_detail", p); //获取帮助详情
export const getInvoiceList = (p) => get("/api/v1.invoice", p); //获取发票列表
export const getInvoiceOrder = (p) => get("/api/v1.invoice/invoice_order", p); //获取发票订单
export const getInstitutionTitle = (p) => get("/api/v1.invoice/institution", p); //获取发票抬头
export const addInvoice = (p) => post("/api/v1.invoice/add_invoice", p); //申请开票
export const scoreLists = (p) => get("/api/v1.institution/score_lists_pc", p); //收益明细

// --------------------翟--------------------
// 品牌秀
export const GetBrandCategory = () => get("/api/v1.brand/category");
export const GetBrandList = (p) => post("/api/v1.brand", p);
export const GetBrandDetail = (p) => post("/api/v1.brand/detail", p);
export const GetBrandGoods = (p) => get("/api/v1.goods", p);

// 商品详情
export const GetGoodsDetail1 = (p) => post("/api/v1.goods/detail", p);
export const ToggleCollect = (p) => post("/api/v1.goods_log/favorite", p);
export const AddCart = (p) => post("/api/v1.cart/update", p);
export const GetSpikesList = (p) => post("/api/v1.goods/activityList", p); //首页获取秒杀列表
export const GetGoods = (p) => get("/api/v1.goods", p);
export const GuessLikeGoods = (p) => get("/api/v1.goods/guess_like", p);


// --------------------晋--------------------
export const GetCarts = (p) => post("/api/v1.cart", p); //购物车列表（商品列表缺"规格"字段，活动商品缺"促销优惠"字段 缺"猜你喜欢"和"最近浏览"接口）
export const CartsDelete = (p) => post("/api/v1.cart/delete", p,true); //购物车删除请求
export const Favorite = (p) => post("/api/v1.goods_log/batch_favorite", p); //收藏列表
export const CartsNumber = (p) => post("/api/v1.cart/update", p); //购物数量
export const GetMessage = (p) => post("/api/v1.message/summary", p); //消息列表（ 缺少客服聊天messageList的icon和createtime_text有问题）
export const GetMessagesList = (p) => post("/api/v1.message/message_list", p); //消息列表
export const GetOrderCalc = (p) => post("/api/v1.order/calc", p); //下单页商品列表 （商品标题前面缺少标签字段，缺少优惠字段）
export const GetAddress = (p) => post("/api/v1.user_address/default", p); //下单页收货人地址
export const Getbusinesslike = (p) => post("/api/v1.index/business_like", p); //注册页
export const Getbusinessdetail = (p) => post("/api/v1.index/business_detail", p); //注册页
export const CheckCode = (p) => post("/api/v1.user/checkCode", p);


//--------------------订单及支付------------------
export const CreateOrder = (p) => post("/api/v1.order/create", p,true); //下单
export const PayDuigongOrder = (p) => post("/api/v1.order/batch_detail", p); //对公支付
export const PayOnline = (p) => post("/api/v1.pay/prepay", p,true); //在线支付
export const PayDuigongOrderSubmit = (p) => post("/api/v1.pay/add_certificate", p,true); //对公支付提交审核
export const PayCheck = (p) => post("/api/v1.pay/check_pay", p); //支付检测
export const AftersaleDetail = (p) => post("/api/v1.aftersale/detail", p); //售后详情
export const AftersaleExpress = (p) => post("/api/v1.aftersale/aftersale_express", p,true); //售后物流
export const AftersaleHome = (p) => post("/api/v1.aftersale/aftersale_home", p,true); //售后上门取件
export const AftersaleCancel = (p) => post("/api/v1.aftersale/cancel", p,true); //售后取消
export const OrderConfirm = (p) => post("/api/v1.order/confirm", p,true); //订单确认收货
export const OrderReport = (p) => post("/api/v1.order/report_upload", p,true); //订单报告
export const UserProfile = (p) => post("/api/v1.user/update", p,true); //用户信息更新
export const CartCount = (p) => post("/api/v1.cart/cart_num", p); //购物车数量
export const OrderCount = (p) => post("/api/v1.user/order_num", p); //订单数量
export const GetMessageListAll = (p) => post("/api/v1.message/message_list_all", p); //消息
export const ReportDel = (p) => post("/api/v1.order/report_del", p,true); //删除报告
export const getPartnerAgreement = (p) => post("/api/v1.singlepage/partner_agreement", p); //合作
export const getRegisterAgreement = (p) => post("/api/v1.singlepage/register_agreement", p); //注册
export const getPurchaseAgreement = (p) => post("/api/v1.singlepage/purchase_agreement", p); //采购